<template>
  <div class="purchaseBox">
    <div v-show="!isSuccess && !isCreated" class="checkPay">
      <i class="iconfont icon-close close cursor" @click="closePurchaseBox()"></i>
      <div v-show="!showShouhuoBox" class="menu">
        <h2 class="mb-2">选择支付方式</h2>
        <div class="mb-3 description text-truncate">{{orderInfo.title}}</div>
        <hr class="mb-4" style="border-color: rgba(0, 0, 0, 0.1);">
        <div class="lis mb-3">
            <span @click="checkPatType(1)" class="cursor" :class="{active:pay===1}">
              <img src="/static/images/aliPay.svg">
              支付宝支付
              <i class="iconfont icon-chenggong"></i>
            </span>
            <span @click="checkPatType(2)" class="cursor" :class="{active:pay===2}">
              <img src="/static/images/wechatPay.svg">
              微信支付
              <i class="iconfont icon-chenggong"></i>
            </span>
            <span v-if="orderInfo.isCredit==='1'" @click="checkPatType(4)" class="cursor" :class="{active:pay===4}">
              <img src="/static/images/shezhang.svg">
              账期下单
              <i class="iconfont icon-chenggong"></i>
            </span>
<!--          <span @click="checkPatType(3)" class="cursor" :class="{active:pay===3}">-->
<!--              <img src="/static/images/payPal.svg">-->
<!--              PayPal（USD）-->
<!--              <i class="iconfont icon-chenggong"></i>-->
<!--            </span>-->
        </div>
        <div>
          <button @click="showShouhuoBox = true" class="btn-light btn btn-lg">{{shouhuoBoolFirst?'上一步':'下一步'}}</button>
          <button v-if="pay===1 && shouhuoBool" class=" btn btn-lg btn-round btn-outline-primary" @click="submitFun">
            <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            前往支付（跳转）<i class="iconfont icon-qianwang"></i>
          </button>
          <button v-if="pay===2 && shouhuoBool" disabled class="btn btn-lg  btn-round btn-outline-primary">
            <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            微信扫描码（二维码）支付...
          </button>
          <button v-if="pay===4 && shouhuoBool" class=" btn btn-lg btn-round btn-outline-primary" @click="submitFunC">
            <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            先下后付<i class="iconfont icon-qianwang"></i>
          </button>
          <span @click="submitFunB" v-if="pay===3 && shouhuoBool" class="btn btn-lg  btn-round btn-outline-primary">
            <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            前往支付（跳转）
          </span>
        </div>
      </div>
      <div class="menu" v-show="showShouhuoBox">
        <p class="text-primary mb-2" :class="{'mb-5':!orderInfo.is_equipment}"><i class="iconfont icon-jinggao"></i> <b>软件发货：激活码在我的订单-详情内发放</b></p>
        <p v-if="orderInfo.is_equipment" class="text-primary"><i class="iconfont icon-jinggao"></i> <b>设备收货：请填写下方的收件地址</b></p>
        <div v-if="orderInfo.is_equipment" class="form-group">
          <input type="text" v-model="mailName" class="form-control form-control-lg">
        </div>
        <div v-if="orderInfo.is_equipment" class="form-group">
          <input type="text" v-model="mailPhone" class="form-control form-control-lg">
        </div>
        <div v-if="orderInfo.is_equipment" class="form-group">
          <input type="text" v-model="mailAddress" class="form-control form-control-lg">
        </div>
        <button type="submit" class="btn btn-primary btn-lg" @click="loginFun">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          确认
        </button>
      </div>
      <div class="price" :class="{'bg-success':pay===2,'bg-primary':pay===1,'bg-paypal':pay===3}">
        <h2 class="m-0 a" v-if="pay===1">￥{{parms.totalPrice}}</h2>
        <img class="mb-3 img-thumbnail" v-if="pay===2 && !isWxpayLoading && isWxpayLoadingSuccess && shouhuoBool" :src="base64">
        <h4 v-if="pay===2 && !shouhuoBool">— 请先确认收件地址 —</h4>
        <i v-if="pay===2 && isWxpayLoading && shouhuoBool" class='iconfont icon-jiazai xuanzhuan'></i>
        <h2 class="m-0 b" v-if="pay===2">￥{{parms.totalPrice}}</h2>
        <h2 class="m-0 c" v-if="pay===3">￥{{parms.totalPrice}}</h2>
        <h2 class="m-0 c" v-if="pay===4">￥{{parms.totalPrice}}</h2>
      </div>
    </div>
    <div v-show="isSuccess && !isCreated" class="checkPay successBox">
      <h1 class="text-primary" v-if="!isPaybool && !isCredit"><i class='iconfont icon-jiazai xuanzhuan'></i> 支付中...</h1>
      <h1 class="text-primary mb-3" v-if="!isPaybool && isCredit"><i class='iconfont icon-jiazai xuanzhuan'></i> 先下后付订单创建中...</h1>
      <h1 v-if="isPaybool && !isCredit" class="text-success"><i class='iconfont icon-chenggong text-success'></i> 支付成功</h1>
      <h1 v-if="isPaybool && isCredit" class="text-success"><i class='iconfont icon-chenggong text-success'></i> 下单成功</h1>
      <p>
        <router-link v-if="!isPaybool" tag='span' class="btn btn-outline-success btn-lg" to="/order">
          支付成功
        </router-link>
        <router-link v-else tag='span' class="btn btn-outline-success btn-lg" to="/order">
          前往订单中心
        </router-link>
        <span @click="closePurchaseBox()" class="btn btn-secondary btn-lg">关闭窗口</span>
      </p>
      <p class="description m-0">
        — 支付遇到问题请联系客服 —
      </p>
    </div>
    <div v-show="isCreated" class="createBox">
      <i class='iconfont icon-jiazai xuanzhuan text-primary'></i>
      <p>创建表单中~</p>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import generalMix from '@/util/mix/general';
import { EventBus } from '@/util/eventBus';
import resultcommons from '../../util/resultcommons';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  name: 'purchaseBox',
  props:['closePurchaseBox','parms'],
  mixins: [generalMix],
  data () {
    return {
      pay:1,
      isLoading:false,// 立即支付按钮 加载 图标
      isSuccess:false,// 是否点击了立即支付按钮
      isCreated:true,// 是否创建了订单目录
      isPaybool:false,// 是否支付成功了
      isWxpayLoading:true, // 加载二维码
      isWxpayLoadingSuccess:false, // 二维码加载成功
      base64:'',
      baseUrl: process.env.BASE_URL,
      orderInfo:{},
      shouhuoBool:false, // 确认过收获则为true
      shouhuoBoolFirst:false,
      showShouhuoBox:false,
      mailName:'',
      mailPhone:'',
      mailAddress:'',
      isCredit:false
    }
  },
  methods:{
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 更新本地缓存
      const localOb = this.localUser;
      localOb.invoiceInfo.mailName = this.mailName;
      localOb.invoiceInfo.mailPhone = this.mailPhone;
      localOb.invoiceInfo.mailAddress = this.mailAddress;
      // 可以执行登录
      resultcommons.apiSaveinvoiceinfo(this, { type:4,no:this.orderInfo.no,token: this.localUser.token, ...localOb.invoiceInfo }).then(app=>{
        if(app.state === 200){
          commons.saveTodos('localUser', localOb);
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          // 切换为修改成功页面
          this.showShouhuoBox = false;
          this.shouhuoBool = true;
          this.shouhuoBoolFirst = true;// 上一步
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    },
    checkPatType(type) {
      this.pay = type;
      // 如果是微信则请求支付二维码
      if(type === 2) {
        // 微信支付
        this.isWxpayLoading = true;
        this.isWxpayLoadingSuccess = false;
        resultcommons.apiWechatpay(this,{no:this.orderInfo.no}).then(app=>{
          if(app.state === 200){
            this.base64 = app.data.base64;
            this.isWxpayLoading = false;
            this.isWxpayLoadingSuccess = true;
            // 创建定时任务
            Window.timerUploadOrder = setInterval(() => {
              this.timerUploadOrder();
            }, 2000);
          }else{
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message
            });
          }
        });
      }else{
        clearInterval(Window.timerUploadOrder);
      }
    },
    // 更新订单支付状态
    timerUploadOrder() {
      // 支付成功
      resultcommons.apiOrdercatalogstate(this,{no:this.orderInfo.no}).then(app=>{
        if(app.state === 200){
          if(app.data.state !== '0'){
            this.isPaybool = true;
            this.isSuccess = true;
            clearInterval(Window.timerUploadOrder);
          }
        }
      });
    },
    submitFunC() {
      return window.swal({
        title: '确认先下后付下单?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          this.isCredit = true;
          // 加载中
          this.isLoading = true;
          // 跳转成功
          this.isSuccess = true;
          // 执行赊账订单任务
          resultcommons.apiOrderinfosetcredit(this,this.orderInfo).then(app=>{
            // 创建定时任务
            Window.timerUploadOrder = setInterval(() => {
              this.timerUploadOrder();
            }, 500);
          });
        }
      });
    },
    submitFun() {
      // 加载中
      this.isLoading = true;
      // 跳转成功
      this.isSuccess = true;
      // 创建定时任务
      Window.timerUploadOrder = setInterval(() => {
        this.timerUploadOrder();
      }, 2000);
      // 执行跳转
      window.open(this.baseUrl + '/alipay/pagepay.html?no=' + this.orderInfo.no, '_blank');
    },
    submitFunB() {
      // 加载中
      this.isLoading = true;
      // 跳转成功
      this.isSuccess = true;
      // 创建定时任务
      Window.timerUploadOrder = setInterval(() => {
        this.timerUploadOrder();
      }, 2000);
      // 执行跳转
      window.open('/paypal/' + this.orderInfo.no, '_blank');
    }
  },
  components: {
  },
  created() {
    this.mailName = this.localUser.invoiceInfo.mailName;
    this.mailPhone = this.localUser.invoiceInfo.mailPhone;
    this.mailAddress = this.localUser.invoiceInfo.mailAddress;
    // 预定义订单
    this.isCreated = true;
    EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
    // resultcommons.apiOrdercatalog(this,{type:this.parms.type,token:this.parms.id,price:this.parms.price,check:this.parms.check,title:this.parms.title}).then(app=>{
    resultcommons.apiOrdercatalog(this,this.parms).then(app=>{
      EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
      if(app.state === 200){
        this.orderInfo = app.data;
        this.isCreated = false;
        // commons.createPostForm('/login',[{title:app.data.title,no:app.data.no,price:app.data.price}],'GET');
        // console.log(app);
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: app.message
        });
        // 关闭表单弹框
        this.isCreated = false;
        this.closePurchaseBox();
      }
    });
  },
  mounted() {
  },
  destroyed() {
    clearInterval(Window.timerUploadOrder);
  }
}
</script>

<style scoped lang='less'>

.purchaseBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  background: rgba(0,0,0,.8);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  .btn{
    &.bg-paypal{
      border-color: #0544B5;
      background: #0544B5;
      &:hover{
        background: #025DCE;
      }
    }
  }
  div.successBox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h1{
      i{
        font-size: 56px;
      }
    }
    span{
      margin-top: 30px;
      margin-bottom: 10px;
    }
    p{

    }
  }
  div.createBox{
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    width: 80vw;
    height: 60vh;
    min-height: 350px;
    border-radius: 10px;
    padding: 15px;
    border: 5px solid #242424;
    margin-top: 10vh;
    margin-bottom: 10vh;
    i{
      font-size: 56px;
      font-weight: bold;
      margin-bottom: 30px;
    }
    p{
      margin: 0;
    }
  }
  div.checkPay{
    width: 80vw;
    height: 60vh;
    min-height: 350px;
    border-radius: 6px;
    padding: 15px 30px;
    padding-right: 15px;
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 10vh;
    margin-bottom: 10vh;
    background: url("/static/images/staticsimg.jpg") no-repeat center center;
    background-size: cover;
    i.close{
      position: absolute;
      top: 30px;
      right: 30px;
      font-size: 28px;
      color: #FFFFFF;
    }
    div.menu{
      flex: 1;
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      div.lis{
        span{
          position: relative;
          margin-right: 20px;
          border: 3px solid rgba(255, 255, 255, 0.2);
          background: rgba(0, 0, 0, 0.3);
          background: #FFFFFF;
          padding: 8px 15px;
          display: inline-block;
          border-radius: 5px;
          margin-bottom: 10px;
          color: #000000;
          &.active{
            border: 3px solid #28A745;
            i{
              display: block;
            }
          }
          img{
            height: 25px;
          }
          &:last-child{
            margin: 0;
          }
          i{
            display: none;
            color: #28A745;
            position: absolute;
            right: -3px;
            bottom: -4px;
          }
        }
      }
    }
    div.price{
      height: 100%;
      min-height: 100px;
      background: #2A37FE !important;
      width: 420px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      color: #FFFFFF;
      h2.a{
        font-size: 58px;
      }
      h2.b{
        font-size: 22px;
      }
      h2.c{
        font-size: 58px;
      }
      img{
        width: 160px;
        //border-radius: 5px;
      }
      i.icon-jiazai{
        font-size: 60px;
        margin-bottom: 20px;
      }
      &.bg-paypal{
        background: #0544B5;
      }
    }
  }
}

@media (max-width: 992px) {
  div.purchaseBox{
    display: block;
    div.checkPay{
      flex-direction: column;
      height: auto;
      min-height: auto;
      display: flex;
      margin-left: auto;
      margin-right: auto;
      div.price{
        width: 100%;
        margin-top: 20px;
        font-size: 36px;
        font-weight: bold;
        padding: 30px 0;
        padding-bottom: 20px;
        div.meiyuan{
          margin-top: 15px;
        }
      }
    }
  }
}

@media (max-width: 776px) {
}

</style>



// WEBPACK FOOTER //
// src/components/common/pay.vue